import { render, staticRenderFns } from "./EditRoom.vue?vue&type=template&id=48324263"
import script from "./EditRoom.vue?vue&type=script&lang=js"
export * from "./EditRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports